import { axios } from '@/services/axios';

const createTrigger = async (formData, scope) => {
    const res = await axios.post('/Trigger/', formData, {
        headers: {
            'X-RequestScope': scope,
        },
    });
    return res.data;
};

export default createTrigger;
